module.exports = __webpack_public_path__ + "static/media/0325_IMG_LES_MURS_METRO_DIAMANTO_BRILLANT_TALCO_HORIZONTALE.ce26b9e4.webp";